// button type
export const SUBMIT_BUTTON_TYPE = 'submit';
export const DELETE_BUTTON_TYPE = 'delete';
